import { render, staticRenderFns } from "./StaticCode.vue?vue&type=template&id=635759bc"
import script from "./StaticCode.vue?vue&type=script&lang=js"
export * from "./StaticCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports